@if (showCloseButton) {
  <button (click)="closeDialog()" class="dialog-close">
    <eon-ui-icon name="close" scheme="grey900"></eon-ui-icon>
  </button>
}
<mat-dialog-content>
  @if (isLoading()) {
    <div class="loading-container">
      <eon-ui-preloader-circle [scheme]="'grey900'" [size]="'small'"></eon-ui-preloader-circle>
    </div>
  } @else {
    <div class="content__inner">
      <h1 class="mb-2">Level {{ this.userService.userLevel() }}</h1>
      <h2>{{ 'dialogs.start.mission' | translate }}</h2>
      <gandalf-typewriter-text [speed]="30"
                               (finished)="onMissionFinished()"
                               [text]="('levels.' + userService.userLevel() + '.mission') | translate"
      >
      </gandalf-typewriter-text>
      <hr/>
      <h2>{{ 'dialogs.start.objectives' | translate }}</h2>
      <p [innerHTML]="('levels.' + userService.userLevel() + '.skill') | translate" class="dialog__introtext"></p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (!isLoading()) {
    @if (this.userService.userLevel() === 1) {
      @if (canStartPrompting()) {
        <eon-ui-button (click)="navigateToGame()" rank="primary" scheme="{{eonUiScheme}}"
                       text="{{ 'buttons.start_prompting' | translate }}"></eon-ui-button>
      }
    } @else {
      <eon-ui-button
              (click)="navigateToGame()"
              rank="primary"
              scheme="{{eonUiScheme}}"
              text="{{'buttons.next_level' | translate:{ level: userService.userLevel() } }}"
      ></eon-ui-button>
    }
  }
</mat-dialog-actions>
